import React, { useState } from 'react'
import { Element } from 'react-scroll'
import SectionTitle2 from '../sectionTitle/SectionTitle2'
import Slider from 'react-slick'

const TestimonialTwo = () => {
  const [seeMore, setSeeMore] = useState();

  const handleSeeMoreclick = (testimonialId) => {
    setSeeMore(testimonialId);
  }

  const clientSuccessStory = [
    {
      id: 1,
      review: "The team is extremely talented, came with an eagerness to learn.  Their participation on this project left a tangible contribution for our company. I'm really impressed with the coach (Sports Agent).",
      name: "Steven Kenway",
      title: "CEO, Rolling Insights"
    },
    {
      id: 2,
      review: "It has been a great experience working with M2M so far. The team has successfully delivered all project deliverables and was even flexible in accommodating an additional requirement later in the project. They also explored different experimentation approaches toward the same goal, making it a valuable exercise.",
      name: "Connor Swain",
      title: "CTO, This Fish"
    },
    {
      id: 3,
      review: "This was an absolutely amazing project. The entire team was very enthusiastic and were chomping at the bit to get started and get working with the data. The entire process was very enlightening, engaging, and amazing.",
      name: "Tayab Soomro",
      title: "CEO, PathoScan Technologies"
    },
    {
      id: 4,
      review: "This has been an excellent partnership, M2M team have developed a very strong working prototype in a short span of time. We appreciate all of the hard work the team put into this and they have been very responsive to our requirements. We look forward to continuing the partnership with M2M!",
      name: "Jerrett Myers",
      title: "Principal, Beam Group"
    },
  ];

  let successStoriesSettings = {
    dots: true,
    infinite: true,
    // autoplay: true,
    className: "center",
    centerMode: true,
    centerPadding: "240px",
    autoplaySpeed: 5000,
    slidesPerRow: 1,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    arrows: false,
    afterChange: () => setSeeMore("")
  };
  
  let successStoriesMobileSettings = {
    dots: true,
    infinite: true,
    // autoplay: true,
    className: "center",
    centerMode: true,
    centerPadding: "20px",
    autoplaySpeed: 5000,
    slidesPerRow: 1,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    arrows: false,
    afterChange: () => setSeeMore("")
  };

  return (
    <Element
      name="ClientSuccessStories"
      className="datatalent-section-gap bg-white"
    >
      <div className="container inner about-feature-list">
        <div className="row g-5">
          <div className="col-12 mt-0 px-0 px-md-4">
            <SectionTitle2
              classes = "text-center"
              title = "Client Success Stories"
            />
          </div>
          <div className="col-12 mt-4 px-0 px-md-4">
            <p className="text-center">Hear from organizations that have transformed their operations with our AI solutions.</p>
          </div>
          <Slider {...successStoriesSettings} className="client-success-stories-slider edu-slick-button slick-button-center d-none d-md-flex align-items-start">
            {clientSuccessStory.map((story) => <div key={story.id}>
              <div className="px-0 px-md-5 py-4">
                <div className="client-ss-card p-5">
                  <div className="client-ss-image">
                    <img src={`${process.env.PUBLIC_URL}/images/icons/quote-2.png`} alt="qoutes" />
                  </div>
                  <div className="client-ss-content mt-5">
                    {/* <p className="mb-4">“<em>{ story.review }</em>”</p> */}
                    {story.review.length > 250 ? (seeMore === story.id) ? <p className="description datatalent-testimonials">“<em>{ story.review }</em>”</p> : <><p className="description datatalent-testimonials">“<em>{ story.review.substring(0, 250) + "..." }</em>”<button onClick={() => handleSeeMoreclick(story.id)} className="datatalent-testimonial-see-more">see more</button></p></>
                      : <p className="description datatalent-testimonials">“<em>{ story.review }</em>”</p>}
                    <p className="mb-0"><strong>{story.name}</strong></p>
                    <p className="mb-0">{story.title}</p>
                  </div>
                </div>
              </div>
            </div>)}
          </Slider>
          <Slider {...successStoriesMobileSettings} className="client-success-stories-slider edu-slick-button slick-button-center d-flex d-md-none px-0 mt-0 align-items-start">
            {clientSuccessStory.map((story) => <div key={story.id}>
              <div className="px-3 px-md-5 py-4">
                <div className="client-ss-card p-4">
                  <div className="client-ss-image">
                    <img src={`${process.env.PUBLIC_URL}/images/icons/quote-2.png`} alt="qoutes" />
                  </div>
                  <div className="client-ss-content mt-5">
                    {story.review.length > 140 ? (seeMore === story.id) ? <p className="description datatalent-testimonials">“<em>{ story.review }</em>”</p> : <><p className="description datatalent-testimonials">“<em>{ story.review.substring(0, 140) + "..." }</em>”<button onClick={() => handleSeeMoreclick(story.id)} className="datatalent-testimonial-see-more">see more</button></p></>
                      : <p className="description datatalent-testimonials">“<em>{ story.review }</em>”</p>}
                    <p className="mb-0"><strong>{story.name}</strong></p>
                    <p className="mb-0">{story.title}</p>
                  </div>
                </div>
              </div>
            </div>)}
          </Slider>
        </div>
      </div>
    </Element>
  )
}

export default TestimonialTwo;